import React from 'react';
import { Shield, TrendingUp, Users, Award } from 'lucide-react';
import { companyInfo, marketContext } from '../mock';

export const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <Shield className="w-4 h-4 text-emerald-600 mr-2" />
              <span className="text-sm font-semibold text-emerald-800">SEBI Regulated AIF</span>
            </div>
            
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-emerald-600">Us</span>
            </h2>
            
            <div className="space-y-8 text-lg text-gray-600 leading-relaxed">
              {/* Greenflow Ventures Section */}
              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-6 border border-emerald-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Greenflow Ventures</h3>
                <p>
                  <strong className="text-gray-900">Greenflow Ventures</strong> is the holding and sponsor company for Credora Capital. As a strategic investment holding company, Greenflow Ventures provides comprehensive oversight, governance, and strategic direction to ensure the highest standards of fund management and investor protection.
                </p>
              </div>

              {/* Credora Capital Section */}
              <div>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-16 h-16 flex items-center justify-center p-1">
                    <img 
                      src="/images/credora-logo-new.png" 
                      alt="Credora Capital"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Credora Capital</h3>
                </div>
                <p>
                  <strong className="text-gray-900">Vision:</strong> {companyInfo.vision}
                </p>
                
                <p className="mt-4">
                  <strong className="text-gray-900">Mission:</strong> {companyInfo.mission}
                </p>
                
                <p className="mt-4">
                  Credora Capital is a thematic fund designed to capitalize on India's vibrant and fast-evolving primary market ecosystem. As a Category I AIF under SEBI regulations, we combine institutional expertise with strategic market positioning.
                </p>
              </div>
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6 mt-10">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <TrendingUp className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Data-Driven</h4>
                  <p className="text-sm text-gray-600">Structured investment approach</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Shield className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Regulation-Aligned</h4>
                  <p className="text-sm text-gray-600">Full SEBI compliance</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Experienced Team</h4>
                  <p className="text-sm text-gray-600">10+ years market experience</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Strategic Focus</h4>
                  <p className="text-sm text-gray-600">SME & IPO specialization</p>
                </div>
              </div>
            </div>
          </div>

          {/* Market Context */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Market Opportunity</h3>
            
            <div className="space-y-6">
              {marketContext.map((context, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-2 h-2 bg-emerald-600 rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">{context}</p>
                </div>
              ))}
            </div>
            
            <div className="mt-8 p-6 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">₹1.25L Cr+</div>
                <div className="text-sm text-gray-600">Raised through IPOs since FY 2020</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};